import startCase from "lodash-es/startCase";

export const EDITOR_EDITED_HIGHLIGHT_CLASS =
  "bg-yellow-100 dark:bg-yellow-900/40";

/** In-card panel header padding (All Sparx list + preview panel title bar). */
export const EDITOR_PANEL_HEADER_PADDING_CLASS = "px-3.5 pt-3.5 pb-2";

export const getEditButtonAriaLabel = (formLabel: string): string =>
  `Edit ${startCase(formLabel)}`;

export const getReturnToPreviewAriaLabel = (): string => "Return to preview";

export const getScrollToEditorHeaderAriaLabel = (): string =>
  "Scroll to section header";
